import surveysQuestionTypes from 'hb-react/shared/utils/surveys/surveysQuestionTypes';

export const responseCountFromQuestionChartData = (question) => {
  if (question.type === surveysQuestionTypes.RADIO) {
    return question.chart_data.reduce((acc, element) => {
      const [, count] = element;

      return acc + count;
    }, 0);
  }
  if (question.type === surveysQuestionTypes.TEXT) {
    return question.chart_data.length;
  }
};

export const questionTitleLabel = (question) => {
  if (question.type === surveysQuestionTypes.RADIO) {
    return s__('Surveys|Multiple select question title');
  }
  if (question.type === surveysQuestionTypes.TEXT) {
    return s__('Surveys|Free text question title');
  }
};
